import ComingSoon from './ComingSoon';

/**
 * Bulk RNA-Seq is not implemented yet.
 *
 * The previous contents were a non-functional mockup (a hardcoded reference-genome
 * dropdown and a fake progress timer) and were removed. This route is intercepted by
 * PipelineGate in App.tsx, so the placeholder below renders only without that gate.
 */
const BulkRNASeq = () => <ComingSoon title="Bulk RNA-Seq" />;

export default BulkRNASeq;
